import Swiper from './../imports/import-swiper';
import { bindCursorHoverEffect } from './cursor.js';
export default ()=>{

  const container = document.getElementById("journal-swiper");
    if (container && screen.width > 1200) {
      const sliders = container.querySelectorAll(".swiper-slide");
      sliders.length > 3 ? journalSlider() : false;
    }
    if (container && screen.width <= 1200) {
      const sliders = container.querySelectorAll(".swiper-slide");
      sliders.length > 1 ? journalSlider() : false;
    }


  function journalSlider() {

    const JournalSlider = new Swiper('#journal-swiper', {
      effect: 'slide',
      allowTouchMove: true,
      touchStartPreventDefault: false,
      loop: false,
      scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          snapOnRelease: true
      },
      autoplay: false,
      slidesPerView: 3,
      spaceBetween: 35,

      watchSlidesProgress:true,
      breakpoints: {
        900: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        620: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        448: {
          slidesPerView: 1,
          spaceBetween: 14,
          loop: true,
          loopAdditionalSlides: 1,
        }
      },
      on: {
        slideChange: () => {
          bindCursorHoverEffect()
        }
      }
  });

  }
}
